<template>
	<div class="container">
		<div class="refund-rules">
			<h1 class="title fs-56 mb-60">Правила отмены и возврата</h1>
			
			<div class="rules-content">
				<p class="fs-20 mb-20">
					При оплате картами возврат наличными денежными средствами не допускается. Порядок возврата регулируется правилами международных платежных систем.
				</p>
				
				<p class="fs-20 mb-20">
					Процедура возврата товара регламентируется статьей 26.1 федерального закона «О защите прав потребителей».
				</p>
				
				<ul class="rules-list fs-20 mb-20">
					<li>Потребитель вправе отказаться от товара в любое время до его передачи, а после передачи товара - в течение семи дней;</li>
					<li>Возврат товара надлежащего качества возможен в случае, если сохранены его товарный вид, потребительские свойства, а также документ, подтверждающий факт и условия покупки указанного товара;</li>
					<li>Потребитель не вправе отказаться от товара надлежащего качества, имеющего индивидуально-определенные свойства, если указанный товар может быть использован исключительно приобретающим его человеком;</li>
					<li>При отказе потребителя от товара продавец должен возвратить ему денежную сумму, уплаченную потребителем по договору, за исключением расходов продавца на доставку от потребителя возвращенного товара, не позднее чем через десять дней со дня предъявления потребителем соответствующего требования;</li>
				</ul>
				
				<p class="fs-20 mb-20">
					Для возврата денежных средств на банковскую карту необходимо заполнить «Заявление о возврате денежных средств», которое высылается по требованию компанией на электронный адрес и оправить его вместе с приложением копии паспорта по адресу <a href="mailto:9825252@gmail.com" class="text-violet">9825252@gmail.com</a>
				</p>
				
				<p class="fs-20 mb-20">
					Возврат денежных средств будет осуществлен на банковскую карту в течение 21 (двадцати одного) рабочего дня со дня получения «Заявление о возврате денежных средств» Компанией.
				</p>
				
				<p class="fs-20 mb-20">
					Для возврата денежных средств по операциям проведенными с ошибками необходимо обратиться с письменным заявлением и приложением копии паспорта и чеков/квитанций, подтверждающих ошибочное списание. Данное заявление необходимо направить по адресу <a href="mailto:9825252@gmail.com" class="text-violet">9825252@gmail.com</a>
				</p>
				
				<p class="fs-20 mb-20">
					Сумма возврата будет равняться сумме покупки. Срок рассмотрения Заявления и возврата денежных средств начинает исчисляться с момента получения Компанией Заявления и рассчитывается в рабочих днях без учета праздников/выходных дней.
				</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'RefundRules'
};
</script>

<style scoped>
.refund-rules {
	max-width: 800px;
	margin: 0 auto;
	padding: 40px 20px;
}

.rules-content {
	line-height: 1.6;
}

.rules-list {
	list-style-type: none;
	padding-left: 0;
}

.rules-list li {
	margin-bottom: 15px;
	padding-left: 20px;
	position: relative;
}

.rules-list li::before {
	content: "•";
	color: #ff6b35;
	font-size: 24px;
	position: absolute;
	left: 0;
	top: 0;
}

.text-violet {
	color: #8b5cf6;
	text-decoration: none;
}

.text-violet:hover {
	text-decoration: underline;
}

.mb-20 {
	margin-bottom: 20px;
}

.mb-60 {
	margin-bottom: 60px;
}

.fs-20 {
	font-size: 20px;
}

.fs-56 {
	font-size: 56px;
}

.title {
	font-weight: 700;
	text-align: center;
}
</style>
